// Single source for the heating-platform stations.
//
// Shared by the HP page (heatingPlatform/index.js) and the global overview
// (globalOverview/IntegratedSystem.js) so the two views can never show
// different stations or segment counts.
//
// NOTE: this is still the placeholder data the HP page has always rendered.
// There is no HP zones endpoint yet (see services/zones.service.js, which has
// getEssZones / getTgsZones / getTesZones only). When one exists, replace this
// module with a slice fed from the API and both views follow automatically.
export const hpStations = [
  {
    id: '1',
    address: 'sharon massachusetts',
    company: 'mbta',
    stationTitle: 'sharon',
    segmentTitles: ['outbound platform', 'inbound platform'],
  },
  {
    id: '2',
    address: 'boston massachusetts',
    company: 'mbta',
    stationTitle: 'blue hill',
    segmentTitles: [
      'cummings highway walkway',
      'outbound platform',
      'inbound platform',
      'blue hill avenue walkway',
    ],
  },
];

// Station rows are titled the same way on both views.
export const getHpStationName = (station) =>
  `${station.company} - ${station.stationTitle}, ${station.address}`;

// Total segments across all stations — the overview's "units" figure for hp.
export const countHpSegments = () =>
  hpStations.reduce(
    (total, station) => total + station.segmentTitles.length,
    0,
  );
